export const LOGIN_ERROR_MESSAGE = 'Username or password is incorrect'

export const SEND_ACCESS_CODE_ERROR_MESSAGE =
  'Unable to send the verification code. Please use the other security method.'

export const COMMON_ERROR_MESSAGE =
"We're unable to process your request right now. Please try again later, or contact your consultant if this problem persists"

  export const PAGE_NOT_FOUND_MESSAGE = 'Page not found, please check you have entered the correct details or contact your consultant for assistance.'